<template>
<div class="organisations">

    <ol class="breadcrumbs">
        <router-link to="/dashboard">Dashboard</router-link> > Organisations
    </ol>
    <div class="d-sm-flex align-items-center justify-content-between mb-4">
        <h1 class="h3 mb-0 text-gray-800">Organisations</h1>
    </div>
    <table class="table table-striped table-bordered table-lg">
        <thead>
            <tr>
                <th>Name</th>
                <th>URL</th>
                <th>Created</th>
                <!--<<th>Collection</th>-->
                <!--<<th>Alt Phone</th>-->
                <th>Accounts Email</th>
                <th>Notes</th>
                <th></th>
                <!--<th>Accounts</th><th>Return</th><th>Attachment</th><th>Items</th>-->
            </tr>
        </thead>
        <tbody v-if="orgs && orgs.length > 0">
            <tr v-bind:class="{disable: org.status==='Disabled'}" class="rw" v-for="(org, index) in orgs" v-bind:key="index">
                <td>{{org.name}}</td>
                <td>/{{org.url}}</td>
                <td :time="org.created">{{org.created | shortDate}}</td>
                <td>{{org.accountsEmail}}</td>
                <!--<td>{{job.collection}}</td>-->
                <td class="col-address">{{org.notes}}</td>
                <td>
                    <router-link :to="{ name: 'timesheet', params:{ orgId: org.url }}">Timesheets</router-link>
                    <router-link class="d-none" :to="{ name: 'org-edit', params:{ orgId: org.url }}">Edit Org</router-link>
                </td>
                <!--
              <td>{{job.accounts}}</td>
              <td>{{job.return}}</td>
              <td>{{job.attachment}}</td>
              <td><span v-for="(item, i) in job.items"  v-bind:key="i">{{item.description}}-{{item.quantity}}</span></td>-->
            </tr>
        </tbody>
    </table>
    <div class="d-none justify-content-center" v-if="user && user.data && user.data.role > 10">
        <router-link class="btn btn-primary" to="/new-user">Add New Organisation</router-link>
    </div>

</div>
</template>

<script>
//import HelloWorld from './components/HelloWorld.vue'
// Get a RTDB instance

import {
    mapGetters
} from "vuex";

export default {
    name: 'Organisations',
    components: {
        // HelloWorld,
    },
    data() {
        return {}
    },
    computed: {
        ...mapGetters({
            user: "user",
            orgs: "orgs"
        })
    },
    created() {
        this.$store.dispatch('bindOrgs')
    },
}
</script>
